import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/Button/button';
import { Link } from '@/i18n/routing';
import { getEmailProviderRedirectUrl } from '@/libs/auth/emailProviderRedirect';

interface ResetPasswordSuccessPopupProps {
  email: string;
}

const ResetPasswordSuccessPopup = ({ email }: ResetPasswordSuccessPopupProps) => {
  const t = useTranslations('sign-in');

  return (
    <div className="flex flex-col h-full">
      <div className="flex w-full mb-4 mt-3">
        <p className="text-white paragraph-m-medium">
          {t('we-v-sent-you-a-letter-to-your-email')}
        </p>
      </div>

      <div className="flex flex-col gap-4 grow overflow-auto">
        <div className="flex border-y border-transparent items-start gap-2.5 bg-main-900 rounded-2xl p-3 bg-main-800/60">
          <div className="flex items-center justify-center min-w-6 min-h-6 bg-main-800 rounded-md -mt-px">
            <p className="paragraph-s-medium text-white w-2 -mr-px">1</p>
          </div>
          <div className="flex flex-col">
            <p className="paragraph-s-medium text-white mb-3">{t('open-your-mailbox')}</p>
            <p className="paragraph-s-medium text-c300 whitespace-pre-line font-normal">
              {t.rich('redeem-card-instruction-text', { email: email || '' })}
            </p>
          </div>
        </div>
        <div className="flex border-y border-transparent items-start gap-2.5 bg-main-900 rounded-2xl p-3 bg-main-800/60">
          <div className="flex items-center justify-center min-w-6 min-h-6 bg-main-800 rounded-md -mt-px">
            <p className="paragraph-s-medium text-white w-2">2</p>
          </div>
          <div className="flex flex-col">
            <p className="paragraph-s-medium text-white mb-3">{t('follow-the-instructions')}</p>
            <p className="paragraph-s-medium whitespace-pre-line font-normal">
              <span className="text-c300 paragraph-s-medium">{t('create-a-new-password-and-confirm-it')}</span>
            </p>
          </div>
        </div>
        <div className="flex border-y border-transparent items-start gap-2.5 bg-main-900 rounded-2xl p-3 bg-main-800/60">
          <div className="flex items-center justify-center min-w-6 min-h-6 bg-main-800 rounded-md -mt-px">
            <p className="paragraph-s-medium text-white w-2">3</p>
          </div>
          <div className="flex flex-col">
            <p className="paragraph-s-medium text-white mb-3">{t('sign-in')}</p>
            <p className="paragraph-s-medium text-c300 font-normal">
              {t('sign-in-using-your-new-password')}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 max-lg:mr-px max-lg:-ml-px">
        <Button
          type="button"
          variant="primary"
          className="w-full py-3"
          asChild
        >
          <Link href={getEmailProviderRedirectUrl(email) ?? ''}>
            {t('go-to-mail')}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ResetPasswordSuccessPopup;
